export default "__VITE_ASSET__K7tdSo1X__"